import { pickEnv } from "./andonLayout.logic";
import type { BoardLayout } from "./andonLayout.types";

import _5e97_staging from "./layouts_5e97/staging";
import a8a5_prod from "./layouts_a8a5/production";
import a8a5_qa from "./layouts_a8a5/qa";
import a8a5_staging from "./layouts_a8a5/staging";
import a8a5_uat from "./layouts_a8a5/uat";

const _5e97_prod: BoardLayout[] = [];
const _5e97_qa: BoardLayout[] = [];
const _5e97_uat: BoardLayout[] = [];

export const andonBoardLayouts: Record<string, BoardLayout[]> = {
  "a8a502f4-3540-4e50-a046-6c2aff6573ab": pickEnv({
    production: a8a5_prod,
    staging: a8a5_staging,
    qa: a8a5_qa,
    uat: a8a5_uat
  }),
  "5e971ce5-67c3-40ef-a0e1-55a76b55bbc7": pickEnv({
    production: _5e97_prod,
    staging: _5e97_staging,
    qa: _5e97_qa,
    uat: _5e97_uat
  })
};

export function getLayoutsForClient(clientId: string | null): BoardLayout[] {
  if (!clientId) return [];
  return andonBoardLayouts[clientId] || [];
}
